// namespace (소문자)
export const NAMESPACE = 'address';
//actions
// export const CREATE_INTERNET_COMMERCE_ESTIMATION = 'CREATE_INTERNET_COMMERCE_ESTIMATION';
export const SEARCH_ADDRESS_LIST = 'SEARCH_ADDRESS_LIST';

//mutations
// export const SET_INTERNET_COMMERCE = 'SET_INTERNET_COMMERCE';
export const SET_ADDRESS_LIST = 'SET_ADDRESS_LIST';

// //state

// //getters
// export const INTERNET_COMMERCE = 'INTERNET_COMMERCE';
export const ADDRESS_LIST = 'ADDRESS_LIST';
